import React from "react";
import "./BlogPage.css";

function PostIoSono() {
  return (
    <div className="main-content">
      <h1 className="home-title">Io Sono: L’Eterno Potere del Sé – Un Viaggio con il Conte di San Germain</h1>
      <p className="blog-date">12 Gennaio 2025</p>

      <div className="blog-image-container">
        <img src="/images/io-sono-1930-libro.jpg" alt="Io Sono Libro" className="blog-image" />
      </div>

      <div className="blog-content">
        <p>
          Nel vasto panorama della letteratura spirituale e mistica, pochi testi riescono a incarnare una saggezza senza tempo come <strong>“Io Sono”</strong>. Attribuito al misterioso e leggendario <strong>Conte di San Germain</strong>, il libro rappresenta una guida illuminante per coloro che desiderano esplorare le profondità dell’esistenza e scoprire la potenza infinita del proprio Sé.
        </p>
        <h2>Introduzione</h2>
        <p>In questo articolo, esploreremo i temi centrali del libro, la figura enigmatica del Conte di San Germain e come i principi esposti in <strong>“Io Sono”</strong> possano arricchire la tua pratica di saggezza stoica.</p>
        <h2>Il Cuore del Messaggio: Il Potere del “Io Sono”</h2>
        <p>Il libro insegna che le parole <strong>“Io Sono”</strong> sono una connessione diretta con l’energia creatrice divina, riconoscendo la nostra natura eterna e illimitata. Pronunciare <strong>“Io Sono”</strong> attiva un potere trasformativo nella nostra realtà.</p>
        <h3>Applicare gli Insegnamenti</h3>
        <ul>
          <li><strong>Affermazioni Giornaliere:</strong> Ripeti “Io Sono pace”, “Io Sono abbondanza”.</li>
          <li><strong>Meditazione:</strong> Concentra il respiro ripetendo mentalmente “Io Sono”.</li>
          <li><strong>Osservazione dei Pensieri:</strong> Sostituisci i pensieri negativi con affermazioni positive.</li>
        </ul>
        <h2>Conclusione</h2>
        <p><strong>“Io Sono”</strong> non è solo un libro, ma una guida per scoprire il tuo potenziale divino. Ogni volta che affermiamo <strong>“Io Sono”</strong>, ci avviciniamo alla nostra vera essenza.</p>
      </div>

      <div className="amazon-links">
        <a
          href="https://amzn.to/3DRCCRX"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-amazon"
        >
          Compra il Libro su Amazon
        </a>
      </div>

      <div className="button-container">
        <a href="https://www.youtube.com/channel/@FrequenzediSaggezzaStoica" target="_blank" rel="noopener noreferrer" className="btn-icon youtube">
          <i className="fab fa-youtube"></i>
        </a>
        <a href="https://www.facebook.com/profile.php?id=61571814955253" target="_blank" rel="noopener noreferrer" className="btn-icon facebook">
          <i className="fab fa-facebook"></i>
        </a>
        <a href="https://www.tiktok.com/@frequenze.di.sagg" target="_blank" rel="noopener noreferrer" className="btn-icon tiktok">
          <i className="fab fa-tiktok"></i>
        </a>
      </div>

      <a href="/blog" className="btn-back">
        Torna al Blog
      </a>
    </div>
  );
}

export default PostIoSono;